export const cashmoneyhelper = {
	format(value) {
		return new Intl.NumberFormat('sv-SE', {
			style: 'currency',
			currency: 'SEK',
			maximumFractionDigits: 2
		}).format(value)
	}
}
